import { Component, OnInit } from '@angular/core';
import { AuthGuard } from '../../core/helper/auth.guard';

import { LocalStorage } from '../../core/helper/localStorage';
import { AppConstants } from '../../app.constant';
import { BaseComponent } from '../../core/component/Base.Component';

@Component({
	moduleId: module.id,
	selector: "navigation-bar",
	templateUrl: '../shell-templates/navigation-bar.component.html'
})

export class NavigationBarComponent extends BaseComponent {
	protected localStorage: LocalStorage;
	today: number = Date.now();
	time: Date;
	constructor(private auth: AuthGuard) {
		super();
		this.localStorage = AppConstants.injector.get(LocalStorage);
	}

	async getCurrenDate() {
		setInterval(() => {
		  var d = new Date(); // for now
		  this.LookupData.time = d.toLocaleTimeString();
		}, 1000);
	  }

	async ngOnInit() {
		await this.getCurrenDate();
	 }

	title = this.localStorage.get('ClientStxt');
	title_short = this.localStorage.get('ClientCode');
	username = this.localStorage.get('User');
	fullname = this.localStorage.get('Fullname');
	userpic = this.localStorage.get('userpic');

	logout() {
		this.navigate('/login');
	}
}



// WEBPACK FOOTER //
// ./src/app/shell/shell-components/navigation-bar.component.ts